import React from "react"
import { Button, Flex } from "antd"
import PropTypes from "prop-types"
import { Icon } from "ui/Icon"
import { Text } from "ui/Typography"
import styles from "./BookingCard.module.css"
import { useTranslation } from "react-i18next"
import { generateBookingLink } from "pages/guide/resources/equipment/modal/DeactivateDelete/utils"
const BookingCard = ({ booking }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.card}>
      {/* Booking Image */}
      {booking.imageUrl && (
        <div className={styles.imageContainer}>
          <img src={booking.imageUrl} alt="" className={styles.blurredBackground} />
          <div className={styles.mediaContent}>
            <img src={booking.imageUrl} alt={booking.experienceName} className={styles.image} />
          </div>
        </div>
      )}

      {/* Booking Details */}
      <Flex vertical gap={12} className={styles.content}>
        {/* Experience Name */}
        <div className={styles.titleContainer}>
          <Text size="lg" fw={500}>{booking.experienceName}</Text>
        </div>

        {/* Booking Info */}
        <Flex vertical gap={6}>
          {/* Location */}
          {booking.location && (
            <Flex align="center" gap={8} className={styles.infoRow}>
              <Icon type="feather" name="MapPin" width={16} height={16} />
              <Text size="s">{booking.location}</Text>
            </Flex>
          )}

          {/* Date */}
          {booking.date && (
            <Flex align="center" gap={8} className={styles.infoRow}>
              <Icon type="feather" name="Calendar" width={16} height={16} />
              <Text size="s">{booking.date}</Text>
            </Flex>
          )}

          {/* Time */}
          {booking.time && (
            <Flex align="center" gap={8} className={styles.infoRow}>
              <Icon type="feather" name="Clock" width={16} height={16} />
              <Text size="s">{booking.time}</Text>
            </Flex>
          )}
        </Flex>

        {/* View Details Button */}
        <Button
          variant="outlined"
          color="primary"
          className="py-l"
          href={generateBookingLink(booking)}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("crewMember.removeExperience.bookingDetails", { defaultValue: "Booking details" })}
        </Button>
      </Flex>
    </div>
  )
}

BookingCard.propTypes = {
  booking: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    experienceName: PropTypes.string.isRequired,
    imageUrl: PropTypes.string,
    location: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    booking_uuid: PropTypes.string
  }).isRequired
}

export default BookingCard
